/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Number/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Number({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite/Number",
  onChange,
  isSubmitting,
  isInvalid
  
}) {
let txCardFieldDefinitionNumberValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'number',
})
let txCardFieldDefinitionNumberIsValidData = fromData.useDataIsValid({ viewPath,
context: 'tx_card_field_definition',
path: 'number',
validate: fromValidate.numberZeroOrPositive,
required: true,
})
let txCardFieldDefinitionNumberChangeData = fromData.useDataChange({ viewPath,
context: 'tx_card_field_definition',
path: 'number',
})
let txCardFieldDefinitionNumberIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_card_field_definition',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 label="Order"
 data="tx_card_field_definition.number"
 value={txCardFieldDefinitionNumberValueData}
 onChange={txCardFieldDefinitionNumberChangeData}
 disabled={txCardFieldDefinitionNumberIsSubmittingData}
 validate="/Data/validate.js numberZeroOrPositive"
 invalid={!txCardFieldDefinitionNumberIsValidData}
 required={true}
 type="number"
 min={0}
/>
{children}
</React.Fragment>)
}